import Spinner from "react-spinkit";
import React from "react";

export default props => (
    <div className="spinner-overlay">
        <Spinner name="line-scale-pulse-out" {...props}/>
    </div>
);